import { FeeScheme, Partners, ProgramCodes, PromoCodes, RenderServiceAgreementRequest, ServiceAgreementType } from '@mesa-labs/mesa-api/dist/types';

import { useSelector } from '../redux/hooks';

function useServiceAgreementQueryArgs(): { type: ServiceAgreementType } & RenderServiceAgreementRequest {
  const address = useSelector((state) => state.vendor.vendor.address);
  const addressAdditional = useSelector((state) => state.vendor.vendor.addressAdditional);
  const addressState = useSelector((state) => state.vendor.vendor.state);
  const businessName = useSelector((state) => state.vendor.vendor.name);
  const city = useSelector((state) => state.vendor.vendor.city);
  const feeScheme = useSelector((state) => state.onboarding.feeScheme);
  const firstName = useSelector((state) => state.vendor.vendor.firstName);
  const lastName = useSelector((state) => state.vendor.vendor.lastName);
  const onboardingId = useSelector((state) => state.vendor.vendor.onboardingId);
  const partnerId = useSelector((state) => state.onboarding.partnerId);
  const programCode = useSelector((state) => state.onboarding.programCode);
  const promoCode = useSelector((state) => state.onboarding.promoCode);
  const zip = useSelector((state) => state.vendor.vendor.zip);

  return {
    type: promoCode === PromoCodes.DIRECT_DEBIT ? ServiceAgreementType.DirectDebit : ServiceAgreementType.Standard,
    partnerId: partnerId || Partners.JLL,
    businessName,
    address,
    addressAdditional,
    city,
    state: addressState,
    zip,
    firstName,
    lastName,
    programCode: programCode || ProgramCodes.NET30,
    onboardingId,
    promoCode,
    hasDirectDebitAuthorization: feeScheme === FeeScheme.DEBITING,
  };
}

export default useServiceAgreementQueryArgs;
